import Meta from '@/utils/RouterMeta'
import Router from "@/utils/Router"
import {order} from "~/router/private/crud"

export const orders = [
    Router.instance({
        path: 'order-today',
        name: 'order-today',
        component: () => import('@/pages/order/today'),
        meta: Meta.instance({
            btnName: 'Суточная информация',
            icon: 'mdi-view-dashboard',
            title: 'СУТОЧНЫЕ',
            permissions: ['logist', 'manager', 'moderator', 'admin']
        }),
    }),
    Router.instance({
        path: 'orders',
        name: 'orders',
        component: () => import('@/pages/order/index'),
        meta: Meta.instance({
            btnName: 'ОБЩИЙ ЖУРНАЛ',
            icon: 'mdi-calendar-clock',
            title: 'ОБЩИЙ ЖУРНАЛ',
            permissions: ['logist', 'manager', 'moderator', 'admin']
        })
    }),
    ...order,
]
